import React from 'react'

const Pagination = ({currentPage, totalPages, handleClick }) => {
  let pagesSize = 2;
  let startPage = currentPage > pagesSize ? currentPage - pagesSize : 1;
  let endPage =
    currentPage < totalPages - pagesSize ? currentPage + pagesSize : totalPages;
  let pages = [...Array(endPage + 1 - startPage).keys()].map(
    (i) => startPage++
  ); 
  // const pages = [...Array(totalPages).keys()].map(num => num+1);
  return (
    <div>
      { pages.map(num => (
        <button
          className={`text-xs sm:text-sm text-center sora font-normal purple-more min-w-[35px] min-h-[35px] mx-1.5 ${currentPage === num ? 'purple-young rounded-full' : ''}`}
          key={num}
          onClick={() => handleClick(num)}
        >{num}</button>
      )) }
    </div>
  )
}

export default Pagination
